export default __webpack_public_path__ + "static/media/rude-mobile.4a422064.webp";